module.exports = __webpack_public_path__ + "img/select-type__01.46cf48c5.png";